module.exports = __webpack_public_path__ + "static/media/bq.ae7b32b5.webp";